import React from 'react';

const SmSubscribeTrackingFormModal = React.lazy(() => import('../components/FormModal'));
const smSubscribeTrackingModalRegistry = {
    notification_smSubscribeTrackingId: SmSubscribeTrackingFormModal
};
export default smSubscribeTrackingModalRegistry;
